<div class="alerts" *ngIf="showAlert">
    <div *ngIf="message !=''" class="d-flex align-items-center form-field-width form-error-container">
        <img src="/assets/icons/Alert.svg" alt="close alert" class="img-alert alert-icon">
        <mat-error  class="common-error form-error-text flex-grow-1">{{message.trim()}}</mat-error>
        <img src="/assets/icons/icon_close_button.svg" alt="close alert" class="img-alert close-alert" role="button" (click)="closeAlert()">
    </div>
</div>
